// src/router/index.js

import { createRouter, createWebHistory } from 'vue-router';

import WeeklyStatus from '@/views/WeeklyStatus.vue';

const routes = [
    {
        path: '/',               // Set '/' as the path for WeeklyStatus
        name: 'WeeklyStatus',
        component: WeeklyStatus
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

// Global Navigation Guard
router.beforeEach(async (to, from, next) => {
    let accessGranted = false;

    // // Detect if the app is running inside Teams
    // const isInTeams = !!(window.microsoftTeams || window.parent !== window);

    // if (isInTeams) {
    //     // Initialize Teams SDK and verify access
    //     try {
    //         await app.initialize();
    //         const context = await app.getContext();
    //         const userId = context.userObjectId;

    //         const response = await fetch(`${process.env.VUE_APP_API_URL}/teams-verify-access`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify({ userId }),
    //         });

    //         const data = await response.json();
    //         accessGranted = data.accessGranted;
    //     } catch (error) {
    //         console.error("Error verifying access in Teams:", error);
    //     }
    // } else {
    //     // For browser, implement your custom access control (e.g., by prompting for login)
    //     try {
    //         // Example: Access control based on session cookies or tokens
    //         const response = await fetch(`${process.env.VUE_APP_API_URL}/browser-verify-access`, {
    //             method: 'GET', // Assume the browser verifies access based on session/cookie
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //         });

    //         const data = await response.json();
    //         accessGranted = data.accessGranted;
    //     } catch (error) {
    //         console.error("Error verifying access in browser:", error);
    //     }
    // }

    accessGranted = true;

    // Route decision
    if (accessGranted) {
        next(); // Allow access
    } else {
        next('/access-denied'); // Redirect to access denied page
    }
});

export default router;
// share this across the app
export const isInTeams = () => !!(window.microsoftTeams || window.parent !== window);
